import { connect } from 'react-redux'
import { setCartDays } from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = { setCartDays }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
